const selectPlan = planType => plan => plan.tier === planType;

const selectPlanAddonProperty = (key, property) => plan => {
  if (!Array.isArray(plan?.plan_addons_info)) {
    return undefined;
  }

  const featureHash = plan.plan_addons_info.find(hash =>
    Object.prototype.hasOwnProperty.call(hash, key),
  );

  if (featureHash && featureHash[key]) {
    return featureHash[key][property];
  }
  return undefined;
};

const selectFeature = key => selectPlanAddonProperty(key, "value");
const selectMonthlyPrice = key =>
  selectPlanAddonProperty(key, "monthly_amount");

export const getPlanAddonValue = (plans, planType, key) => {
  const plan = plans.find(selectPlan(planType));
  const featureValue = selectFeature(key)(plan);
  return featureValue ?? "";
};

export const getPlanAddonPrice = (plans, planType, key) => {
  const plan = plans.find(selectPlan(planType));
  const monthlyPrice = selectMonthlyPrice(key)(plan);
  return monthlyPrice ?? "";
};
